import { Component, inject, signal, effect } from '@angular/core';
import { AnalyticsService } from '../analytics.service';
import { BrowserService } from '../browser.service';

@Component({
  selector: 'app-font-toggle',
  templateUrl: './font-toggle.component.html',
  styleUrl: './font-toggle.component.scss',
})
export class FontToggleComponent {
  private readonly browser = inject(BrowserService);
  private readonly analytics = inject(AnalyticsService);

  readonly enabled = signal(false);

  constructor() {
    effect(() => {
      if (this.browser.isBrowser) {
        document.body.classList.toggle('dyslexic-font', this.enabled());
      }
    });
  }

  toggle(): void {
    this.enabled.set(!this.enabled());
    this.analytics.trackEvent('accessibility_font_toggle', { enabled: this.enabled() });
  }
}
